import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "error" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "input-group"
}
const _hoisted_12 = {
  key: 1,
  class: "input-group"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "row mt-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "row mt-3" }
const _hoisted_21 = ["onClick"]

import { computed, onMounted, watch, shallowReactive, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog'
    import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue'
    import { MonthYear, MonthYearHelpers, ValidationError } from '@common/types'
    import { usePortfolioSettingsQueryV1 } from '@Quest/Portfolios/queries-vue-composables'
    import { useUpdatePortfolioSettingsCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    import type {
        LinkableItemReadModel,
        PortfolioSettingsReadModel
    } from '@Quest/Portfolios/readmodels'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioSettingsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))


    // ======================
    // Query
    // ======================

    const {
        runPortfolioSettingsQueryV1,
        modelPortfolioSettingsQueryV1
    } = usePortfolioSettingsQueryV1(workspaceId, tchProjectId)

    const rm = modelPortfolioSettingsQueryV1 as Ref<PortfolioSettingsReadModel | null>
    const strategyId = computed(() => rm.value?.StrategyId ?? '')
    const portfolioId = computed<string | null>(() => rm.value?.Id ?? null)


    // ======================
    // Command
    // ======================

    const {
        invokeUpdatePortfolioSettingsCommandV1,
        onSucceedUpdatePortfolioSettingsCommandV1,
        invokingUpdatePortfolioSettingsCommandV1,
        validationErrorsUpdatePortfolioSettingsCommandV1
    } = useUpdatePortfolioSettingsCommandV1(workspaceId, portfolioId)


    // ======================
    // State
    // ======================

    const name = computed({
        get: () => rm.value?.Name ?? null,
        set: (val: string | null) =>
        {
            if (rm.value) rm.value.Name = val
        }
    })

    const description = computed({
        get: () => rm.value?.Description ?? null,
        set: (val: string | null) =>
        {
            if (rm.value) rm.value.Description = val
        }
    })

    const benefitsConfidenceDate = computed({
        get: () => rm.value?.BenefitsConfidenceDate ?? null,
        set: (val: MonthYear | null) =>
        {
            if (rm.value) rm.value.BenefitsConfidenceDate = val
        }
    })


    const benefitsConfidenceDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const nameError = computed(() => validationErrorsUpdatePortfolioSettingsCommandV1.value?.find(error => error.Context === 'Name')?.Error ?? null)
    const benefitsConfidenceDateLabel = computed(() => MonthYearHelpers.toMonthYearLongString(benefitsConfidenceDate.value))


    // ======================
    // Methods
    // ======================

    function toggleLinkage(i: LinkableItemReadModel)
    {
        i.IsLinked = !i.IsLinked
    }

    function showBenefitsConfidenceDateMonthPicker()
    {
        benefitsConfidenceDateMonthPicker.show(
            benefitsConfidenceDate.value,
            'End of benefits confidence',
            false
        )
    }

    function handleUpdateBenefitsConfidenceDate(date: MonthYear | null)
    {
        benefitsConfidenceDate.value = date
    }

    function handleUpdatePortfolioSettingsCommand()
    {
        if (!rm.value) return

        const excludedResourceIds =
            rm.value.Resources.filter(a => !a.IsLinked).map(a => a.Id)

        const excludedRevenueIds =
            rm.value.Revenues.filter(a => !a.IsLinked).map(a => a.Id)

        const excludedExpenseIds =
            rm.value.Expenses.filter(a => !a.IsLinked).map(a => a.Id)

        const excludedCapexIds =
            rm.value.Capex.filter(a => !a.IsLinked).map(a => a.Id)

        invokeUpdatePortfolioSettingsCommandV1({
            name: name.value!,
            description: description.value,
            benefitsConfidenceDate: benefitsConfidenceDate.value,
            excludedResourceIds,
            excludedRevenueIds,
            excludedExpenseIds,
            excludedCapexIds
        })
    }


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = 'Portfolio | TransparentChoice'
        runPortfolioSettingsQueryV1()
    })

    onSucceedUpdatePortfolioSettingsCommandV1(() =>
    {
        alert('Portfolio settings updated successfully')
        runPortfolioSettingsQueryV1()
    })


    watch(validationErrorsUpdatePortfolioSettingsCommandV1, (current, previous) =>
    {
        if (current?.length && current !== previous)
        {
            alert('Sth went wrong')
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(benefitsConfidenceDateMonthPicker),
      onUpdateDate: handleUpdateBenefitsConfidenceDate
    }, null, 8 /* PROPS */, ["viewModel"]),
    (_unref(rm))
      ? (_openBlock(), _createBlock(CorporateNavigation, {
          key: 0,
          ActivePage: "portfolios",
          propStrategyId: strategyId.value
        }, null, 8 /* PROPS */, ["propStrategyId"]))
      : _createCommentVNode("v-if", true),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Settings")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _unref(invokingUpdatePortfolioSettingsCommandV1),
                class: "btn btn-outline-secondary",
                style: {"padding":"0.7em 2em"},
                form: "portfolio-settings-form"
              }, "Save settings", 8 /* PROPS */, _hoisted_4)
            ])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("form", {
            id: "portfolio-settings-form",
            onSubmit: _withModifiers(handleUpdatePortfolioSettingsCommand, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Portfolio name:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                type: "text",
                class: "form-control",
                required: "",
                maxlength: "100",
                minlength: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  name.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(nameError.value), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  description.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, "End of benefits confidence:", -1 /* CACHED */)),
                  (benefitsConfidenceDate.value == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[6] || (_cache[6] = _createElementVNode("input", {
                          value: `Not defined`,
                          type: "text",
                          class: "form-control",
                          readonly: ""
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary",
                            type: "button",
                            onClick: showBenefitsConfidenceDateMonthPicker
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", {
                              class: "fa-regular fa-calendar",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (benefitsConfidenceDate.value != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("input", {
                          value: benefitsConfidenceDateLabel.value,
                          type: "text",
                          class: "form-control",
                          readonly: ""
                        }, null, 8 /* PROPS */, _hoisted_13),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary",
                            type: "button",
                            onClick: showBenefitsConfidenceDateMonthPicker
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", {
                              class: "fa-regular fa-calendar",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Revenues:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Revenues, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-4 col-lg-4 mt-1",
                  key: r.Id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block text-left", r.IsLinked ? 'btn-outline-success' : 'btn-light']),
                    onClick: ($event: any) => (toggleLinkage(r))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", r.IsLinked ? 'fa-square-check' : 'fa-square'])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString(r.Name), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_15)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Resources:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Resources, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-4 col-lg-4 mt-1",
                  key: r.Id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block text-left", r.IsLinked ? 'btn-outline-success' : 'btn-light']),
                    onClick: ($event: any) => (toggleLinkage(r))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", r.IsLinked ? 'fa-square-check' : 'fa-square'])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString(r.Name), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_17)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Expense accounts:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Expenses, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-4 col-lg-4 mt-1",
                  key: r.Id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block text-left", r.IsLinked ? 'btn-outline-success' : 'btn-light']),
                    onClick: ($event: any) => (toggleLinkage(r))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", r.IsLinked ? 'fa-square-check' : 'fa-square'])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString(r.Name), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_19)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[16] || (_cache[16] = _createElementVNode("h4", null, "Capex accounts:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Capex, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-4 col-lg-4 mt-1",
                  key: r.Id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block text-left", r.IsLinked ? 'btn-outline-success' : 'btn-light']),
                    onClick: ($event: any) => (toggleLinkage(r))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", r.IsLinked ? 'fa-square-check' : 'fa-square'])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString(r.Name), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_21)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 32 /* NEED_HYDRATION */),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})